import { Box, Button, Modal, Typography } from "@mui/material";
import { SxProps, useTheme } from "@mui/material/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import useButtonStyles from "../../styles/useButtonStyles";
import { ReactElement, useState } from "react";
import { redirect, useNavigate } from "react-router-dom";

export interface BasicModalPropTypes {
  title?: string;
  success?: boolean;
  setState?: Function;
  content?: ReactElement;
  open?: boolean;
  toggleModal?: Function;
  children?: React.ReactNode;
  reference?: string;
  redirection?: string;
  sx?: SxProps;
  disableAutoFocus?: boolean;
  onCloseModule?: Function;
}

const BasicModal = (props: BasicModalPropTypes) => {
  const {
    title,
    success,
    setState,
    content,
    reference,
    redirection,
    sx = {},
    open,
    toggleModal,
    disableAutoFocus,
    onCloseModule,
  } = props;
  const theme = useTheme();
  const buttonStyles = useButtonStyles();
  const navigate = useNavigate();
  // const [open, setOpen] = useState<boolean>(true);

  const onCloseToRedirect = () => {
    setState && setState(false);
    redirection && navigate(redirection);
    onCloseModule && onCloseModule();
  };

  return (
    <div>
      <Modal
        open={open ?? true}
        disableAutoFocus={disableAutoFocus ?? false}
        onClose={() => {}}
        onBackdropClick={toggleModal ? () => toggleModal(false) : () => {}}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "none",
          outline: "none",
          "&:focus": {
            outline: "none",
          },
        }}
      >
        {content ? (
          content
        ) : (
          <Box
            sx={{
              backgroundColor: theme?.color?.background,
              py: 2,
              px: 5,
              borderRadius: "8px",
              border: "none",
              outline: "none",
              "&:focus": {
                outline: "none",
              },
              ...sx,
            }}
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              textAlign={"center"}
              sx={{
                textAlign: "center",
                color: theme?.color?.primary,
                fontWeight: 600,
                fontFamily: theme?.font?.fontFamily.primary,
                letterSpacing: 0.7,
                my: 2,
              }}
            >
              {title}
            </Typography>
            {reference && (
              <Typography
                id="member"
                variant="h6"
                textAlign={"center"}
                sx={{
                  textAlign: "center",
                  color: theme?.color?.primary,
                  fontWeight: 300,
                  fontFamily: theme?.font?.fontFamily.primary,
                  letterSpacing: 0.7,
                  my: 2,
                }}
              >
                {reference}
              </Typography>
            )}

            {success ? (
              <CheckCircleIcon
                sx={{ fontSize: "5rem", color: theme?.color?.success, py: 2 }}
              />
            ) : (
              <CancelIcon
                sx={{ fontSize: "5rem", color: theme?.color?.failure, py: 2 }}
              />
            )}
            <Button
              size="small"
              sx={{
                height: "2rem",
                ...buttonStyles.outlinedSecondary,
                my: 2,
              }}
              onClick={onCloseToRedirect}
            >
              close
            </Button>
          </Box>
        )}
      </Modal>
    </div>
  );
};

export default BasicModal;
